import { themes } from "../MatxTheme/initThemes";
import layout1Settings from "./Layout1/Layout1Settings";

const SiteSettings = {
  LOCAL: {
    id: "local",
    // TODO: DO NOT put a trailing slash on URLs!
    // URLs that are created by app append there one slash
    // TODO: Fix this so it doesn't matter
    baseURL: "http://localhost:5213",
    sponsorsImage: "/assets/images/sponsors.png",
  },
  VOT: {
    id: "vot",
    baseURL: "https://api-vot.clouddx.io",
    sponsorsImage: "/assets/images/sponsors-vot.png",
  },
  TBS: {
    id: "tbs",
    baseURL: "https://api-tbs.clouddx.io",
    sponsorsImage: "/assets/images/sponsors-tbs.png",
    removeColumnsFromPatientSummary: [2, 3, 5, 7, 8, 9],
  },
};

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html
export const MatxLayoutSettings = {
  activeLayout: "layout1", // layout1, layout2
  activeTheme: "blue", // View all valid theme colors inside MatxTheme/themeColors.js
  perfectScrollbar: false,

  themes: themes,
  layout1Settings, // open Layout1/Layout1Settings.js

  siteSettings: {
    ...SiteSettings.TBS,
  },

  secondarySidebar: {
    show: false,
    open: false,
    theme: "slateDark1", // View all valid theme colors inside MatxTheme/themeColors.js
  },
  // Footer options
  footer: {
    show: false,
    fixed: false,
    theme: "slateDark1", // View all valid theme colors inside MatxTheme/themeColors.js
  },
};
